<!-- Page Wrapper -->
<div class="bg-[#FAFAFA] rounded-[20px] p-4 sm:p-6">

  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
    <h1 class="text-lg sm:text-xl font-semibold text-[#444A6D]">
      {{ 'DISBURSEMENT.TITLE' | translate }}
    </h1>

    <div class="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
      <button *ngIf="selectedFacilityIds.length > 0" [disabled]="isAnySelectedRestructured()" class="bg-indigo-600 text-white text-sm px-4 py-2 rounded-lg 
         hover:bg-indigo-700 disabled:bg-gray-300 disabled:cursor-not-allowed" (click)="openRestructureConfirm()">
        {{ 'DISBURSEMENT.PROCESS_RESTRUCTURE_COUNT' | translate: { count: selectedFacilityIds.length } }}
      </button>
      <button
        class="bg-white text-indigo-600 border border-indigo-600 text-sm px-4 py-2 rounded-lg hover:bg-indigo-50 w-full sm:w-auto"
        (click)="openCalculateAccrued()">
        {{ 'DISBURSEMENT.CALCULATE_ACCRUED' | translate }}
      </button>
      <button class="bg-indigo-600 text-white text-sm px-4 py-2 rounded-lg hover:bg-indigo-600 w-full sm:w-auto"
        (click)="addNewFacility()">
        {{ 'DISBURSEMENT.ADD_NEW' | translate }}
      </button>
    </div>
  </div>

  <!-- Filters -->
  <div class=" p-4 mb-4 ">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg">
      <div>
        <label class="form-label">{{ 'DISBURSEMENT.CLIENT' | translate }}</label>
        <select class="form-input" [(ngModel)]="selectedClientId" (change)="onClientChange()">
          <option [ngValue]="null">{{ 'DISBURSEMENT.ALL_CLIENTS' | translate }}</option>
          <option *ngFor="let client of clients" [value]="client.clientSeq">{{ client.name }}</option>
        </select>
      </div>

      <!-- <div>
        <label class="form-label">Facility</label>
        <select class="form-input">
          <option>Select</option>
        </select>
      </div> -->
    </div>
  </div>

  <!-- Desktop Table -->
  <div class="relative overflow-x-auto w-full mt-4">
    @if (totalRecords > 0) {
    <app-table #mainTable [columns]="facilityTableColumns" [data]="paginatedFacilities" [actions]="facilityTableActions"
      [selectable]="true" (selectionChange)="onSelectionChange($event)">
    </app-table>
    }

    @if (totalRecords === 0) {
    <div
      class="flex flex-col items-center justify-center p-12 text-center bg-white rounded-xl border border-dashed border-gray-300 mt-4">
      <div class="h-16 w-16 bg-indigo-50 rounded-full flex items-center justify-center mb-4">
        <svg class="w-8 h-8 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01">
          </path>
        </svg>
      </div>
      <h3 class="text-lg font-medium text-gray-900 mb-1">{{ 'DISBURSEMENT.NO_FACILITIES_FOUND' | translate }}</h3>
      <p class="text-gray-500 text-sm max-w-sm">
        {{ 'DISBURSEMENT.NO_FACILITIES_HINT' | translate }}
      </p>
    </div>
    }
  </div>


  <!-- Pagination -->
  <div class="table-pagination">
    <span>
      {{ 'COMMON.SHOWING_RECORDS' | translate: { start: startRecord, end: endRecord, total: totalRecords } }}
    </span>

    <div class="table-pager">
      <button type="button" class="table-pager-btn" (click)="prevPage()" [disabled]="currentPage === 1">
        {{ 'COMMON.PREVIOUS' | translate }}
      </button>

      @for (page of pages; track $index) {
        @if (page === null) {
          <span class="table-pager-btn table-pager-gap">…</span>
        } @else {
          <button
            type="button"
            class="table-pager-btn"
            [class.is-active]="page === currentPage"
            [attr.aria-current]="page === currentPage ? 'page' : null"
            (click)="goToPage(page)"
          >
            {{ page }}
          </button>
        }
      }

      <button type="button" class="table-pager-btn" (click)="nextPage()" [disabled]="endRecord === totalRecords">
        {{ 'COMMON.NEXT' | translate }}
      </button>
    </div>
  </div>

</div>

<!-- Edit Facility Details model  -->
@if (showEditFacility) {
<app-popup [(show)]="showEditFacility" [title]="isCreateMode ? 'DISBURSEMENT.ADD_FACILITY' : 'DISBURSEMENT.EDIT_FACILITY'"
  width="w-full max-w-5xl" [fields]="facilityPopupFields" [onSave]="onFacilityPopupSave"
  (formChange)="onFacilityFieldChange($event)">
</app-popup>
}
<!-- Accrued Income Payment Popup (Consolidated Modal) -->
@if (showAccruedIncomePaymentModal) {
<div class="fixed inset-0 z-[99999] ">
  <app-popup [(show)]="showAccruedIncomePaymentModal" title="DISBURSEMENT.PAY_ACCRUED_INCOME" width="w-full max-w-lg"
    [fields]="accruedIncomePaymentPopupFields" [data]="accruedIncomePaymentFormData"
    [onSave]="onAccruedIncomePaymentPopupSave" (formChange)="onAccruedIncomePaymentFormChange($event)">
  </app-popup>
</div>
}





<!-- repayment model -->
@if (showRepaymentList) {
<app-popup [(show)]="showRepaymentList" title="DISBURSEMENT.CONSOLIDATED_REPAYMENTS" width="w-full max-w-4xl" type="custom">
  <app-table [columns]="repaymentTableColumns" [data]="repayments" [actions]="repaymentTableActions">
  </app-table>
  <!-- Footer -->
  <div class="px-6 py-4 border-t flex justify-end mt-4">
    <button class="btn-danger" (click)="closeAll()">{{ 'COMMON.CLOSE' | translate }}</button>
  </div>
</app-popup>
}


<!-- Disbursement List Modal (NEW) -->
@if (showDisbursementList) {
<app-popup [(show)]="showDisbursementList" title="DISBURSEMENT.DISBURSEMENTS" width="w-full max-w-5xl" type="custom">

  <div class="flex justify-between mb-4">
    <div class="buttons flex justify-center items-center gap-5">

      <!-- Pending Schedule Icon -->
      <button class="h-9 w-9   rounded-lg flex items-center justify-center " (click)="openPendingSchedules()"
        [title]="'DISBURSEMENT.PENDING_SCHEDULES' | translate">

        <img src="/public/2.png" alt="">

      </button>
    </div>

    <!-- Add Disbursement -->
    <button class="bg-indigo-600 text-white text-sm px-4 py-2 rounded-lg hover:bg-indigo-700"
      (click)="onAddNewDisbursement()">
      {{ 'DISBURSEMENT.ADD_NEW' | translate }}
    </button>

  </div>

  <app-table [columns]="disbursementTableColumns" [data]="disbursementList" [actions]="disbursementTableActions">
  </app-table>

  <div class="px-6 py-4 border-t flex justify-end mt-4">
    <button class="btn-danger" (click)="showDisbursementList = false">{{ 'COMMON.CANCEL' | translate }}</button>
  </div>

</app-popup>
}
@if (showAccruedMarkupTable) {

<app-popup [(show)]="showAccruedMarkupTable" title="DISBURSEMENT.ACCRUED_MARKUP" width="w-full max-w-5xl" type="custom">

  <app-table [columns]="accruedMarkupColumns" [data]="accruedMarkupList" [actions]="accruedMarkupActions">
  </app-table>

  <div class="px-6 py-4 border-t flex justify-end mt-4">
    <button class="btn-danger" (click)="showAccruedMarkupTable = false">
      {{ 'COMMON.CLOSE' | translate }}
    </button>
  </div>

</app-popup>

}

<!-- Accrued Markup Payment Popup -->
@if (showAccruedMarkupPaymentModal) {
<app-popup [(show)]="showAccruedMarkupPaymentModal" title="DISBURSEMENT.PAY_ACCRUED_MARKUP" width="w-full max-w-lg"
  [fields]="accruedMarkupPaymentPopupFields" [onSave]="onAccruedMarkupPaymentPopupSave">
</app-popup>
}
<!-- Schedule List Modal (Rich Payment Details) -->
@if (showScheduleList) {
<app-popup [(show)]="showScheduleList" (showChange)="onScheduleModalVisibilityChange($event)"
  [title]="disbursementSummary.facilityName ? ('DISBURSEMENT.PAYMENT_SCHEDULE_FOR' | translate: { name: disbursementSummary.facilityName.trim() }) : 'DISBURSEMENT.PAYMENT_SCHEDULE'"
  width="w-full max-w-6xl" type="custom">

  <!-- ── Summary Dashboard ── -->
  @if (paymentDetails) {
  <div class="mb-6">

    <!-- Summary Cards -->
    <div class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
      <div class="bg-white rounded-xl border border-gray-100 px-4 py-3.5">
        <p class="text-[11px] uppercase tracking-wider text-[#8A8FB9] font-medium mb-1">{{ 'DISBURSEMENT.TOTAL_SCHEDULES' | translate }}</p>
        <p class="text-xl font-bold text-[#05004E]">{{ disbursementSummary.totalSchedules }}</p>
      </div>
      <div class="bg-white rounded-xl border border-gray-100 px-4 py-3.5">
        <p class="text-[11px] uppercase tracking-wider text-[#8A8FB9] font-medium mb-1">{{ 'DISBURSEMENT.PAID' | translate }}</p>
        <p class="text-xl font-bold text-[#00B69B]">{{ disbursementSummary.paidSchedules }}</p>
      </div>
      <div class="bg-white rounded-xl border border-gray-100 px-4 py-3.5">
        <p class="text-[11px] uppercase tracking-wider text-[#8A8FB9] font-medium mb-1">{{ 'COMMON.PENDING' | translate }}</p>
        <p class="text-xl font-bold text-[#F97316]">{{ disbursementSummary.pendingSchedules }}</p>
      </div>
      <div class="bg-white rounded-xl border border-gray-100 px-4 py-3.5">
        <p class="text-[11px] uppercase tracking-wider text-[#8A8FB9] font-medium mb-1">{{ 'DISBURSEMENT.DISBURSED_AMOUNT' | translate }}</p>
        <p class="text-lg font-bold text-[#605BFF]">{{ disbursementSummary.disbursementAmount | currency:'PKR
          ':'symbol':'1.0-0' }}</p>
      </div>
    </div>

    <!-- Financial Summary Bar -->
    <div class="bg-white rounded-xl border border-gray-100 px-4 py-3.5">
      <div class="flex flex-wrap items-center justify-between gap-3 mb-2.5">
        <div class="flex items-center gap-5 text-[13px]">
          <span class="text-[#8A8FB9]">{{ 'DISBURSEMENT.PAID_LABEL' | translate }}
            <strong class="text-[#00B69B] ms-1">{{ disbursementSummary.totalPaidAmount | currency:'PKR
              ':'symbol':'1.0-0' }}</strong>
          </span>
          <span class="text-[#8A8FB9]">{{ 'DISBURSEMENT.REMAINING_LABEL' | translate }}
            <strong class="text-[#F97316] ms-1">{{ disbursementSummary.totalRemainingAmount | currency:'PKR
              ':'symbol':'1.0-0' }}</strong>
          </span>
        </div>
        <div class="flex items-center gap-2">
          @if (disbursementSummary.fullyPaid) {
          <span
            class="px-3 py-1 rounded-full text-[11px] font-semibold bg-[#E8FFF3] text-[#00B69B] uppercase tracking-wider">{{ 'DISBURSEMENT.FULLY_PAID' | translate }}</span>
          } @else {
          <span class="text-sm font-bold text-[#605BFF]">{{ disbursementSummary.progressPercentage }}%</span>
          }
        </div>
      </div>
      <!-- Progress Bar -->
      <div class="w-full bg-[#F0F0F5] rounded-full h-2">
        <div class="h-2 rounded-full transition-all duration-500 ease-out"
          [class]="disbursementSummary.fullyPaid ? 'bg-[#00B69B]' : 'bg-[#605BFF]'"
          [style.width.%]="disbursementSummary.progressPercentage">
        </div>
      </div>
    </div>

  </div>
  }

  <!-- ── Schedule Rows with Payment History ── -->
  <div class="schedule-scroll-area space-y-3 max-h-[55vh] overflow-y-auto pe-1">
    @for (schedule of scheduleList; track schedule.pymtSchdSeq) {
    <div class="rounded-xl bg-white transition-all duration-200" [class]="expandedScheduleIds.has(schedule.pymtSchdSeq)
        ? 'border border-indigo-200 shadow-sm'
        : 'border border-gray-100 hover:shadow-sm'">

      <!-- Schedule Row Header -->
      <div class="flex items-center gap-3 px-4 py-3.5 cursor-pointer transition-colors"
        [class]="schedule.stsKey === 8 ? 'bg-[#FAFDF9] rounded-xl' : 'bg-white rounded-xl'"
        (click)="togglePaymentHistory(schedule.pymtSchdSeq)">

        <!-- Expand Arrow -->
        <span class="text-[#8A8FB9] text-[10px] w-4 flex-shrink-0 transition-transform duration-200"
          [class.rotate-90]="expandedScheduleIds.has(schedule.pymtSchdSeq)">
          ▶
        </span>

        <!-- Installment Number Badge -->
        <div class="w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
          [class]="schedule.stsKey === 8 ? 'bg-[#E8FFF3] text-[#00B69B]' : 'bg-indigo-50 text-[#605BFF]'">
          {{ schedule.instNum }}
        </div>

        <!-- Schedule Info Grid -->
        <div class="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-1 text-[13px]">
          <div>
            <p class="text-[10px] text-[#8A8FB9] uppercase tracking-wider font-medium">{{ 'DISBURSEMENT.DUE_DATE' | translate }}</p>
            <p class="font-semibold text-[#444A6D]"><span dir="ltr">{{ schedule.dueDt | date:'MMM dd, yyyy' }}</span></p>
          </div>
          <div>
            <p class="text-[10px] text-[#8A8FB9] uppercase tracking-wider font-medium">{{ 'DISBURSEMENT.DUE_AMOUNT' | translate }}</p>
            <p class="font-bold text-[#05004E]">{{ schedule.dueAmt | currency:'PKR ':'symbol':'1.0-0' }}</p>
          </div>
          <div>
            <p class="text-[10px] text-[#8A8FB9] uppercase tracking-wider font-medium">{{ 'DISBURSEMENT.PAID' | translate }}</p>
            <p class="font-bold text-[#00B69B]">{{ schedule.paidAmt | currency:'PKR ':'symbol':'1.0-0' }}</p>
          </div>
          <div>
            <p class="text-[10px] text-[#8A8FB9] uppercase tracking-wider font-medium">{{ 'DISBURSEMENT.REMAINING' | translate }}</p>
            <p class="font-bold" [class]="schedule.remainingAmount > 0 ? 'text-[#F97316]' : 'text-[#00B69B]'">
              {{ schedule.remainingAmount | currency:'PKR ':'symbol':'1.0-0' }}
            </p>
          </div>
        </div>

        <!-- Status Badge -->
        <span class="px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider flex-shrink-0"
          [class]="schedule.stsKey === 8 ? 'bg-[#E8FFF3] text-[#00B69B]' : 'bg-[#FFF4E5] text-[#F97316]'">
          {{ schedule.status | translate }}
        </span>

        <!-- Action Buttons -->
        <div class="flex items-center gap-2 flex-shrink-0" (click)="$event.stopPropagation()">
          @if (schedule.remainingAmount > 0) {
          <button class="icon-btn" [class.bg-purple-50]="isPaymentAllowed(schedule) && !isScheduleLocked()"
            [class.text-purple-600]="isPaymentAllowed(schedule) && !isScheduleLocked()"
            [class.hover:bg-purple-100]="isPaymentAllowed(schedule) && !isScheduleLocked()"
            [class.bg-gray-100]="!isPaymentAllowed(schedule) || isScheduleLocked()"
            [class.text-gray-400]="!isPaymentAllowed(schedule) || isScheduleLocked()"
            [disabled]="!isPaymentAllowed(schedule) || isScheduleLocked()" [title]="'DISBURSEMENT.MAKE_PAYMENT' | translate"
            (click)="isPaymentAllowed(schedule) && !isScheduleLocked() && openSchedulePayment(schedule)">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0
      1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12
      12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303
      0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0
      11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
          }
          <button *ngIf="canEditSchedule(schedule)" class="icon-btn bg-indigo-50 text-indigo-600 hover:bg-indigo-100"
            [title]="'DISBURSEMENT.EDIT_SCHEDULE' | translate" (click)="openEditSchedule(schedule)">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652
      2.652L10.582 16.07a4.5 4.5 0 01-1.897
      1.13L6 18l.8-2.685a4.5 4.5 0
      011.13-1.897l8.932-8.931z" />
            </svg>
          </button>
        </div>
      </div>

      <!-- ── Expanded Payment History ── -->
      @if (expandedScheduleIds.has(schedule.pymtSchdSeq)) {
      <div class="border-t border-gray-100 bg-[#FAFAFB] px-5 py-3.5 rounded-b-xl">
        @if (schedule.paymentCount > 0 && schedule.payments?.length) {
        <div class="flex items-center gap-2 mb-3">
          <span class="text-[11px] uppercase tracking-wider font-semibold text-[#8A8FB9]">{{ 'DISBURSEMENT.PAYMENT_HISTORY' | translate }}</span>
          <span
            class="text-[10px] bg-[#605BFF] text-white font-bold w-5 h-5 rounded-full flex items-center justify-center">
            {{ schedule.paymentCount }}
          </span>
        </div>

        <!-- Payment Records -->
        <div class="space-y-2">
          @for (payment of schedule.payments; track payment.pymtDtlSeq) {
          <div class="bg-white rounded-lg border-s-[3px] px-4 py-3 text-[13px] shadow-[0_1px_2px_rgba(0,0,0,0.04)]"
            [class.border-l-[#00B69B]]="payment.adjustmentType === 'FULL'"
            [class.border-l-[#605BFF]]="payment.adjustmentType === 'PARTIAL'">
            <div class="grid grid-cols-2 sm:grid-cols-6 gap-x-5 gap-y-2">
              <div>
                <p class="text-[10px] text-[#8A8FB9] uppercase tracking-wider font-medium">{{ 'COMMON.AMOUNT' | translate }}</p>
                <p class="font-bold text-[#05004E]">{{ payment.adjustedAmount | currency:'PKR ':'symbol':'1.0-0' }}</p>
              </div>
              <div>
                <p class="text-[10px] text-[#8A8FB9] uppercase tracking-wider font-medium">{{ 'COMMON.TYPE' | translate }}</p>
                <span class="inline-block px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider"
                  [class]="payment.adjustmentType === 'FULL' ? 'bg-[#E8FFF3] text-[#00B69B]' : 'bg-indigo-50 text-[#605BFF]'">
                  {{ payment.adjustmentType | translate }}
                </span>
              </div>
              <div>
                <p class="text-[10px] text-[#8A8FB9] uppercase tracking-wider font-medium">{{ 'DISBURSEMENT.TRX_ID' | translate }}</p>
                <p class="font-mono text-[#444A6D]">{{ payment.trxId }}</p>
              </div>
              <div>
                <p class="text-[10px] text-[#8A8FB9] uppercase tracking-wider font-medium">{{ 'DISBURSEMENT.CHEQUE_NO' | translate }}</p>
                <p class="font-mono text-[#444A6D] truncate" [title]="payment.chqNum">{{ payment.chqNum }}</p>
              </div>
              <div>
                <p class="text-[10px] text-[#8A8FB9] uppercase tracking-wider font-medium">{{ 'DISBURSEMENT.ENTRY_DATE' | translate }}</p>
                <p class="text-[#444A6D]"><span dir="ltr">{{ payment.sysEntryDt | date:'MMM dd, yyyy HH:mm' }}</span></p>
              </div>
              <div>
                <p class="text-[10px] text-[#8A8FB9] uppercase tracking-wider font-medium">{{ 'DISBURSEMENT.POSTING_DATE' | translate }}</p>
                <p class="text-[#444A6D]"><span dir="ltr">{{ payment.pstngDt | date:'MMM dd, yyyy HH:mm' }}</span></p>
              </div>
            </div>
          </div>
          }
        </div>
        } @else {
        <div class="flex items-center gap-2 py-2">
          <svg class="w-4 h-4 text-[#8A8FB9]" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p class="text-[13px] text-[#8A8FB9] italic">{{ 'DISBURSEMENT.NO_PAYMENT_RECORDS' | translate }}</p>
        </div>
        }
      </div>
      }

    </div>
    }
  </div>

  <!-- Footer -->
  <div class="px-6 py-4 border-t border-gray-100 flex justify-end mt-4 gap-3">
    <button class="btn-danger" (click)="showScheduleList = false">{{ 'COMMON.CANCEL' | translate }}</button>
    @if (isScheduleDirty) {
    <button class="btn-primary" (click)="saveAllSchedules()">{{ 'DISBURSEMENT.SAVE_AND_CLOSE' | translate }}</button>
    }
  </div>

</app-popup>
}


<!-- Edit Repayment Modal -->
@if (showEditRepayment) {
<app-popup [(show)]="showEditRepayment" [title]="isRepaymentCreateMode ? 'DISBURSEMENT.ADD_REPAYMENT' : 'DISBURSEMENT.EDIT_REPAYMENT'"
  width="w-full max-w-4xl" [fields]="repaymentPopupFields" [onSave]="onRepaymentPopupSave">
</app-popup>
}


@if (showAssuredIncom) {
<app-popup [(show)]="showAssuredIncom" [title]="accruedIncomeTitle" width="w-full max-w-6xl" type="custom">
  <!-- Summary Section -->
  <div class="px-6 py-4 bg-gradient-to-r from-blue-50 to-indigo-50 border-b">
    <div class="grid grid-cols-4 gap-4">
      <div class="text-center">
        <p class="text-xs text-gray-600 font-medium">{{ 'DISBURSEMENT.FACILITY' | translate }}</p>
        <p class="text-lg font-bold text-gray-900">{{ accruedIncomeSummary.facilityName || ('COMMON.N_A' | translate) }}</p>
      </div>
      <div class="text-center">
        <p class="text-xs text-gray-600 font-medium">{{ 'DISBURSEMENT.TOTAL_ACCRUED' | translate }}</p>
        <p class="text-lg font-bold text-green-600">{{ accruedIncomeSummary.totalAccrued | currency:'PKR
          ':'symbol':'1.0-0' }}</p>
      </div>
      <div class="text-center">
        <p class="text-xs text-gray-600 font-medium">{{ 'DISBURSEMENT.PAID_ACCRUED' | translate }}</p>
        <p class="text-lg font-bold text-blue-600">{{ accruedIncomeSummary.paidAccrued | currency:'PKR
          ':'symbol':'1.0-0' }}</p>
      </div>
      <div class="text-center">
        <p class="text-xs text-gray-600 font-medium">{{ 'DISBURSEMENT.REMAINING' | translate }}</p>
        <p class="text-lg font-bold text-orange-600">{{ accruedIncomeSummary.remainingAccrued | currency:'PKR
          ':'symbol':'1.0-0' }}</p>
      </div>
    </div>
  </div>

  <!-- Monthly Accrued Income List -->
  <div class="px-6 py-4 max-h-96 overflow-y-auto">
    @if (accruedIncomeByMonth.length === 0) {
    <p class="text-center text-gray-500 py-8">{{ 'DISBURSEMENT.NO_ACCRUED_INCOME_DATA' | translate }}</p>
    } @else {
    <div class="space-y-3">
      @for (monthGroup of accruedIncomeByMonth; track monthGroup.monthYear) {
      <!-- Month Header Row -->
      <div class="border rounded-lg bg-white hover:bg-gray-50 cursor-pointer transition"
        (click)="toggleAccruedMonth(monthGroup.monthYear)">
        <div class="px-4 py-3 flex items-center justify-between">
          <div class="flex items-center gap-3 flex-1">
            <input type="checkbox" class="h-4 w-4" [checked]="isAccruedMonthSelected(monthGroup.monthYear)"
              [disabled]="!canPayAccruedMonth(monthGroup)" (click)="$event.stopPropagation()"
              (change)="toggleAccruedMonthSelection(monthGroup, $event)" />
            <span class="inline-flex items-center justify-center w-6 h-6 text-sm font-bold text-gray-600">
              {{ isAccruedMonthExpanded(monthGroup.monthYear) ? '▼' : '▶' }}
            </span>
            <div class="grid grid-cols-4 gap-6 flex-1">
              <div>
                <p class="text-xs text-gray-600">{{ 'DISBURSEMENT.MONTH_YEAR' | translate }}</p>
                <p class="font-semibold text-gray-900">{{ monthGroup.monthYear }}</p>
              </div>
              <div>
                <p class="text-xs text-gray-600">{{ 'DISBURSEMENT.TOTAL_ACCRUED' | translate }}</p>
                <p class="font-semibold text-green-600">{{ monthGroup.totalAccrued | currency:'PKR ':'symbol':'1.0-0' }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-600">{{ 'DISBURSEMENT.PAID' | translate }}</p>
                <p class="font-semibold text-blue-600">{{ monthGroup.paidAccrued | currency:'PKR ':'symbol':'1.0-0' }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-600">{{ 'DISBURSEMENT.REMAINING' | translate }}</p>
                <p class="font-semibold text-orange-600">{{ monthGroup.remainingAccrued | currency:'PKR
                  ':'symbol':'1.0-0' }}</p>
              </div>
            </div>
          </div>
          <div class="ms-4 flex-shrink-0" (click)="$event.stopPropagation()">
            @if (canPayAccruedMonth(monthGroup)) {
            <button
              class="h-8 w-8 bg-purple-100 text-purple-500 rounded-full flex items-center justify-center font-bold hover:bg-purple-200 transition"
              (click)="openAccruedIncomePayment(monthGroup)" [title]="'DISBURSEMENT.PAY_MONTH' | translate">
              💵
            </button>
            }
          </div>
        </div>

        <!-- Expandable Details -->
        @if (isAccruedMonthExpanded(monthGroup.monthYear)) {
        <div class="border-t bg-gray-50 px-4 py-3">
          <div class="overflow-x-auto">
            <table class="w-full text-sm">
              <thead>
                <tr class="text-xs font-semibold text-gray-700 bg-gray-100">
                  @for (col of accruedIncomeDetailTableColumns; track col.key) {
                  <th class="px-3 py-2 text-start">{{ col.label | translate }}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (detail of monthGroup.details; track detail.accrudMrkUpSeq) {
                <tr class="border-t hover:bg-white transition">
                  @for (col of accruedIncomeDetailTableColumns; track col.key) {
                  <td class="px-3 py-2">
                    @if (col.type === 'currency') {
                    {{ detail[col.key] | currency:'PKR ':'symbol':'1.0-0' }}
                    } @else if (col.type === 'map' && col.map) {
                    {{ col.map[detail[col.key]] || detail[col.key] }}
                    } @else {
                    {{ detail[col.key] }}
                    }
                  </td>
                  }
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>

  <!-- Footer -->
  <div class="px-6 py-4 border-t flex justify-end gap-2 mt-4">
    <button class="btn-primary" [disabled]="selectedAccruedMonthCount === 0" (click)="openAccruedIncomePayment()">
      {{ 'DISBURSEMENT.PAY_SELECTED_COUNT' | translate: { count: selectedAccruedMonthCount } }}
    </button>
    <button class="btn-danger" (click)="showAssuredIncom = false">{{ 'COMMON.CLOSE' | translate }}</button>
  </div>
</app-popup>
}

<!-- Accrued Payment Popup -->
@if (showAccruedPaymentModal) {
<app-popup [(show)]="showAccruedPaymentModal" title="DISBURSEMENT.CONFIRM_PAYMENT" width="w-full max-w-md" type="custom">

  <div class="p-6 text-center">
    <p class="text-gray-700 text-sm" [innerHTML]="'DISBURSEMENT.CONFIRM_MARK_ACCRUED_PAID' | translate">
    </p>

    <p class="mt-2 text-xs text-gray-500">
      {{ 'DISBURSEMENT.MONTH_VALUE' | translate: { month: selectedAccruedPayment.monthYear } }}
    </p>
  </div>

  <div class="px-6 py-4 border-t flex justify-end gap-3">
    <button class="btn-danger" (click)="showAccruedPaymentModal = false">
      {{ 'COMMON.NO' | translate }}
    </button>

    <button class="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700" (click)="confirmAccruedPayment()">
      {{ 'DISBURSEMENT.YES_CONFIRM' | translate }}
    </button>
  </div>

</app-popup>
}

<!-- Schedule Payment Popup (Full or Partial) -->
@if (showSchedulePaymentModal) {
<app-popup [(show)]="showSchedulePaymentModal" title="DISBURSEMENT.MARK_SCHEDULE_PAID" width="w-full max-w-lg"
  [fields]="schedulePaymentPopupFields" [onSave]="onSchedulePaymentPopupSave"
  (formChange)="onSchedulePaymentFieldChange($event)">
</app-popup>
}
@if (showPendingSchedules) {

<app-popup [(show)]="showPendingSchedules" title="DISBURSEMENT.PENDING_SCHEDULES" width="w-full max-w-6xl" type="custom">

  <div class="table-wrapper">

    <table class="table">

      <!-- HEADER -->
      <thead class="table-head">
        <tr>
          <th class="w-10"></th>
          <th>{{ 'DISBURSEMENT.MONTH' | translate }}</th>
          <th>{{ 'DISBURSEMENT.CALCULATION_MONTH' | translate }}</th>
          <th>{{ 'DISBURSEMENT.TOTAL_AMOUNT' | translate }}</th>
          <th>{{ 'DISBURSEMENT.NO_OF_SCHEDULES' | translate }}</th>
          <th>{{ 'COMMON.STATUS' | translate }}</th>
        </tr>
      </thead>

      <!-- BODY -->
      <tbody class="table-body">

        @for (group of pendingScheduleList; track group.month) {

        <!-- MAIN ROW -->
        <tr class="table-row cursor-pointer hover:bg-gray-50" (click)="togglePendingRow(group.month)">

          <td class="table-cell-start text-xs">

            <span class="transition-transform" [class.rotate-90]="expandedPendingRows.has(group.month)">
              ▶
            </span>

          </td>

          <td class="table-cell font-semibold">
            {{ group.month }}
          </td>

          <td class="table-cell">
            {{ group.monthYearOfCalc }}
          </td>

          <td class="table-cell font-semibold">
            {{ group.totalAmount | number }}
          </td>

          <td class="table-cell">
            {{ group.numberOfSchedules }}
          </td>

          <!-- STATUS -->
          <td class="table-cell">
            {{ getPicklistMap(PKL_GRP.DISBURSEMENT_PAYMENT_TYPE)[group.stsKey] | translate }}
          </td>

        </tr>

        <!-- EXPANDED ROW -->
        @if (expandedPendingRows.has(group.month)) {

        <tr class="table-row bg-gray-50">

          <td colspan="6" class="table-cell p-4">

            <!-- INNER TABLE -->
            <app-table [columns]="pendingScheduleInnerColumns" [data]="group.schedules">
            </app-table>

          </td>

        </tr>

        }

        }

      </tbody>

    </table>

  </div>

  <!-- FOOTER -->
  <div class="px-6 py-4 border-t flex justify-end mt-4">
    <button class="btn-danger" (click)="showPendingSchedules = false">
      {{ 'COMMON.CLOSE' | translate }}
    </button>
  </div>

</app-popup>

}
<!-- Repayment Payment Popup (Full Only) -->
@if (showRepaymentPaymentModal) {
<app-popup [(show)]="showRepaymentPaymentModal" title="DISBURSEMENT.MARK_REPAYMENT_PAID" width="w-full max-w-lg"
  [fields]="repaymentPaymentPopupFields" [onSave]="onRepaymentPaymentPopupSave">
</app-popup>
}

<!-- Disbursement Modal -->
@if (showDisbursementModal) {
<app-popup [(show)]="showDisbursementModal" title="DISBURSEMENT.FACILITY_DISBURSEMENT" width="w-full max-w-5xl"
  [fields]="disbursementPopupFields" [onSave]="onDisbursementPopupSave">
</app-popup>

}

<!-- Edit Schedule Popup -->
@if (showEditSchedule) {
<app-popup [(show)]="showEditSchedule" title="DISBURSEMENT.EDIT_SCHEDULE" width="w-full max-w-lg" [fields]="schedulePopupFields"
  [onSave]="onSchedulePopupSave">
</app-popup>
}

<!-- Calculate Accrued Modal -->
@if (showCalculateAccruedModal) {
<app-popup [(show)]="showCalculateAccruedModal" title="DISBURSEMENT.CALCULATE_ACCRUED" width="w-full max-w-lg" type="custom">
  <div class="p-6">
    <label class="block text-sm font-medium text-gray-700 mb-2">{{ 'DISBURSEMENT.SELECT_MONTH_YEAR' | translate }}</label>
    <input type="month"
      class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
      [(ngModel)]="calculationMonthYear">
  </div>
  <!-- Footer -->
  <div class="px-6 py-4 border-t flex justify-end mt-4 gap-3">
    <button class="btn-danger" (click)="showCalculateAccruedModal = false">{{ 'COMMON.CANCEL' | translate }}</button>
    <button class="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700"
      (click)="calculateAccrued()">{{ 'DISBURSEMENT.CALCULATE' | translate }}</button>
  </div>
</app-popup>
}

@if (showPenaltyModal) {

<app-popup [(show)]="showPenaltyModal" title="DISBURSEMENT.PENALTY_LIST" width="w-full max-w-5xl" type="custom">

  <app-table [columns]="penaltyTableColumns" [data]="penaltyList">
  </app-table>

  <div class="px-6 py-4 border-t flex justify-end mt-4">
    <button class="btn-danger" (click)="showPenaltyModal = false">
      {{ 'COMMON.CLOSE' | translate }}
    </button>
  </div>

</app-popup>

}

@if (showRestructureConfirm) {
<app-popup [(show)]="showRestructureConfirm" title="DISBURSEMENT.CONFIRM_RESTRUCTURE" width="w-full max-w-md" type="custom">

  <div class="p-6 text-center">
    <p class="text-gray-700 text-sm">
      {{ 'DISBURSEMENT.CONFIRM_RESTRUCTURE_MSG' | translate }}
    </p>
  </div>

  <div class="px-6 py-4 border-t flex justify-end gap-3">
    <button class="btn-danger" (click)="showRestructureConfirm = false">
      {{ 'COMMON.CANCEL' | translate }}
    </button>

    <button class="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700" (click)="confirmRestructure()">
      {{ 'DISBURSEMENT.YES_PROCEED' | translate }}
    </button>
  </div>

</app-popup>
}

<!-- Delete Disbursement Confirmation Modal -->
@if (showDeleteConfirmModal) {
<app-popup [(show)]="showDeleteConfirmModal" title="DISBURSEMENT.CONFIRM_DELETE" width="w-full max-w-md" type="custom">
  <div class="p-6">
    <p class="text-gray-700 mb-2">
      {{ 'DISBURSEMENT.CONFIRM_DELETE_DISBURSEMENT' | translate }}
    </p>
    <p class="text-sm text-gray-500">
      <strong>{{ 'DISBURSEMENT.DATE_LABEL' | translate }}</strong> <span dir="ltr">{{ selectedDisbursementForDelete?.dsbmntDt | date:'MMM dd, yyyy' }}</span><br>
      <strong>{{ 'DISBURSEMENT.AMOUNT_LABEL' | translate }}</strong> {{ selectedDisbursementForDelete?.dsbmntAmt | currency:'PKR':'symbol':'1.0-0' }}
    </p>
    <p class="text-red-600 text-sm font-semibold mt-3">
      {{ 'DISBURSEMENT.ACTION_CANNOT_BE_UNDONE' | translate }}
    </p>
  </div>

  <div class="px-6 py-4 border-t flex justify-end gap-3">
    <button class="btn-secondary" (click)="cancelDeleteDisbursement()">
      {{ 'COMMON.CANCEL' | translate }}
    </button>
    <button class="btn-danger" (click)="confirmDeleteDisbursement()" [disabled]="loading">
      {{ (loading ? 'DISBURSEMENT.DELETING' : 'COMMON.DELETE') | translate }}
    </button>
  </div>

</app-popup>
}